(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function initFooterAccordions() {
    const footer = document.querySelector('.site-footer.section-site-footer');
    if (!footer) return;

    const accordions = footer.querySelectorAll('.site-footer__accordion');
    if (!accordions.length) return;

    const desktopQuery = window.matchMedia('(min-width: 48rem)');

    function syncFooterAccordions() {
      accordions.forEach((accordion) => {
        if (desktopQuery.matches) {
          accordion.setAttribute('open', '');
          return;
        }

        accordion.removeAttribute('open');
      });
    }

    syncFooterAccordions();

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', syncFooterAccordions);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(syncFooterAccordions);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-botica-objects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.home-store--objects [data-home-objects-carousel]');
    if (!root) return;

    const track = root.querySelector('[data-home-objects-track]');
    const dots = [...root.querySelectorAll('[data-home-objects-dot]')];
    const slides = () => [...root.querySelectorAll('.home-store__grid--objects .botica-product-card')];

    const mobileCarouselQuery = window.matchMedia('(max-width: 47.99rem)');
    const tabletCarouselQuery = window.matchMedia('(min-width: 48rem) and (max-width: 989px)');
    let scrollFrame = null;

    function getScroller() {
      return isCarouselMode() ? track : null;
    }

    function isCarouselMode() {
      return mobileCarouselQuery.matches || tabletCarouselQuery.matches;
    }

    function setActiveSlide(index) {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      slides().forEach((slide, slideIndex) => {
        slide.classList.toggle('is-slide-active', slideIndex === index);
      });
    }

    function updateActiveSlide() {
      const scroller = getScroller();
      if (!scroller) return;

      const items = slides();
      if (!items.length) return;

      const scrollerCenter = scroller.scrollLeft + scroller.clientWidth / 2;
      let activeIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      items.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(scrollerCenter - slideCenter);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      setActiveSlide(activeIndex);
    }

    function scrollToSlide(index) {
      const scroller = getScroller();
      if (!scroller) return;

      const slide = slides()[index];
      if (!slide) return;

      slide.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        inline: tabletCarouselQuery.matches ? 'start' : 'center',
        block: 'nearest',
      });
    }

    function bindDots() {
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number.parseInt(dot.dataset.homeObjectsDot || '0', 10);
          scrollToSlide(index);
        });
      });
    }

    function bindScroll() {
      if (!track) return;

      track.addEventListener(
        'scroll',
        () => {
          if (!isCarouselMode()) return;

          if (scrollFrame) {
            window.cancelAnimationFrame(scrollFrame);
          }

          scrollFrame = window.requestAnimationFrame(updateActiveSlide);
        },
        { passive: true }
      );
    }

    function onCarouselModeChange() {
      if (isCarouselMode()) {
        updateActiveSlide();
        return;
      }

      slides().forEach((slide) => {
        slide.classList.remove('is-slide-active');
      });
      setActiveSlide(0);
    }

    bindDots();
    bindScroll();
    updateActiveSlide();

    mobileCarouselQuery.addEventListener('change', onCarouselModeChange);
    tabletCarouselQuery.addEventListener('change', onCarouselModeChange);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-archive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-lifestyle-archive]');
    if (!root || root.dataset.lifestyleArchiveInit === 'true') return;
    root.dataset.lifestyleArchiveInit = 'true';

    const filterButtons = [...root.querySelectorAll('[data-lifestyle-filter]')];
    const cards = [...root.querySelectorAll('[data-lifestyle-category]')];
    const emptyMessage = root.querySelector('[data-lifestyle-archive-empty]');

    if (!filterButtons.length || !cards.length) return;

    function applyFilter(filter) {
      let visibleCount = 0;

      filterButtons.forEach((button) => {
        const isActive = button.dataset.lifestyleFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      cards.forEach((card) => {
        const show = filter === 'all' || card.dataset.lifestyleCategory === filter;
        card.hidden = !show;
        if (show) {
          visibleCount += 1;
        }
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount > 0;
      }
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.dataset.lifestyleFilter || 'all');
      });
    });

    applyFilter('all');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.getElementById('locations');
    if (!root) return;

    root.querySelectorAll('[data-locations-hours-toggle]').forEach((toggle) => {
      const card = toggle.closest('[data-locations-card]');
      const panel = card && card.querySelector('[data-locations-hours-panel]');
      const icon = toggle.querySelector('[data-locations-hours-icon]');
      if (!card || !panel) return;

      toggle.addEventListener('click', () => {
        const isOpen = card.classList.toggle('is-hours-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (icon) {
          icon.textContent = isOpen ? '▲' : '▼';
        }
        if (isOpen) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-our-story-pillars-carousel]');
    if (!root) return;

    const track = root.querySelector('[data-our-story-pillars-track]');
    const dots = [...root.querySelectorAll('[data-our-story-pillars-dot]')];
    const mobileMq = window.matchMedia('(max-width: 47.99rem)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let scrollFrame = null;

    function slides() {
      return [...root.querySelectorAll('.our-story__pillar-card')];
    }

    function setActiveSlide(index) {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateActiveSlide() {
      if (!mobileMq.matches || !track) return;

      const items = slides();
      if (!items.length) return;

      const scrollerCenter = track.scrollLeft + track.clientWidth / 2;
      let activeIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      items.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(scrollerCenter - slideCenter);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      setActiveSlide(activeIndex);
    }

    function scrollToSlide(index) {
      if (!mobileMq.matches || !track) return;

      const slide = slides()[index];
      if (!slide) return;

      slide.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number.parseInt(dot.dataset.ourStoryPillarsDot || '0', 10);
        scrollToSlide(index);
      });
    });

    track?.addEventListener(
      'scroll',
      () => {
        if (!mobileMq.matches) return;

        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(updateActiveSlide);
      },
      { passive: true }
    );

    const onMobileChange = () => {
      if (mobileMq.matches) {
        updateActiveSlide();
        return;
      }

      setActiveSlide(0);
    };

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', onMobileChange);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(onMobileChange);
    }

    if (mobileMq.matches) {
      updateActiveSlide();
    }
  })();

  (function () {
    const root = document.querySelector('[data-our-story-timeline-carousel]');
    if (!root) return;

    const track = root.querySelector('[data-our-story-timeline-track]');
    const prevButton = root.querySelector('[data-our-story-timeline-prev]');
    const nextButton = root.querySelector('[data-our-story-timeline-next]');
    const mobileMq = window.matchMedia('(max-width: 47.99rem)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let scrollFrame = null;

    function slides() {
      return [...root.querySelectorAll('.our-story__timeline-item')];
    }

    function setActiveSlides(activeIndexes) {
      slides().forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', activeIndexes.has(slideIndex));
      });
    }

    function updateNavState() {
      if (!track || !prevButton || !nextButton) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      prevButton.disabled = track.scrollLeft <= 1;
      nextButton.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function updateActiveSlide() {
      if (!track) return;

      const items = slides();
      if (!items.length) return;

      const viewportLeft = track.scrollLeft;
      const viewportRight = viewportLeft + track.clientWidth;
      const scrollerCenter = viewportLeft + track.clientWidth / 2;
      const activeIndexes = new Set();

      if (mobileMq.matches) {
        let activeIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        items.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(scrollerCenter - slideCenter);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            activeIndex = index;
          }
        });

        activeIndexes.add(activeIndex);
      } else {
        items.forEach((slide, index) => {
          const slideLeft = slide.offsetLeft;
          const slideRight = slideLeft + slide.offsetWidth;
          const isVisible = slideRight > viewportLeft + 1 && slideLeft < viewportRight - 1;

          if (isVisible) {
            activeIndexes.add(index);
          }
        });
      }

      setActiveSlides(activeIndexes);
      updateNavState();
    }

    function scrollTimeline(direction) {
      if (!track) return;

      if (!mobileMq.matches) {
        const pageWidth = track.clientWidth;
        const maxScroll = Math.max(0, track.scrollWidth - pageWidth);
        const targetScroll = Math.min(maxScroll, Math.max(0, track.scrollLeft + pageWidth * direction));

        track.scrollTo({
          left: targetScroll,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
        return;
      }

      const items = slides();
      const scrollerCenter = track.scrollLeft + track.clientWidth / 2;
      let activeIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      items.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(scrollerCenter - slideCenter);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      const target = items[activeIndex + direction];

      if (!target) return;

      target.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }

    prevButton?.addEventListener('click', () => {
      scrollTimeline(-1);
    });

    nextButton?.addEventListener('click', () => {
      scrollTimeline(1);
    });

    track?.addEventListener(
      'wheel',
      (event) => {
        if (mobileMq.matches || !track) return;

        const horizontalDelta = Math.abs(event.deltaX);
        const verticalDelta = Math.abs(event.deltaY);

        if (horizontalDelta >= verticalDelta) return;

        if (verticalDelta < 2) return;

        event.preventDefault();
        track.scrollLeft += event.deltaY;
      },
      { passive: false }
    );

    track?.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(updateActiveSlide);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(updateActiveSlide);
      },
      { passive: true }
    );

    const onBreakpointChange = () => {
      updateActiveSlide();
    };

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', onBreakpointChange);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(onBreakpointChange);
    }

    updateActiveSlide();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-contact-panel-root]');
    if (!root) return;

    const dialog = root.querySelector('[data-contact-dialog]');
    const titleEl = root.querySelector('[data-contact-panel-title]');
    const openButtons = document.querySelectorAll('[data-contact-open]');
    const closeTargets = root.querySelectorAll('[data-contact-close]');
    const views = root.querySelectorAll('[data-contact-panel-view]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let activePanel = null;
    let isScrollLocked = false;
    let savedScrollY = 0;

    function lockBackgroundScroll() {
      if (isScrollLocked) return;

      savedScrollY = window.scrollY;
      document.body.dataset.contactScrollY = String(savedScrollY);
      document.body.classList.add('contact-modal-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.overscrollBehavior = 'none';
      document.body.style.touchAction = 'none';
      window.cervusFormScrollGuard?.activate?.('contact-modal');
      isScrollLocked = true;
    }

    function unlockBackgroundScroll() {
      if (!isScrollLocked) return;

      const restoreY =
        Number.parseInt(document.body.dataset.contactScrollY || String(savedScrollY), 10) || 0;

      document.body.classList.remove('contact-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.overscrollBehavior = '';
      document.body.style.touchAction = '';
      delete document.body.dataset.contactScrollY;
      window.cervusFormScrollGuard?.deactivate?.('contact-modal');

      try {
        window.scrollTo({ top: restoreY, left: 0, behavior: 'instant' });
      } catch {
        window.scrollTo(0, restoreY);
      }

      window.cervusHeaderScroll?.syncScrollY?.(restoreY);
      savedScrollY = restoreY;
      isScrollLocked = false;
    }

    function showView(panelId) {
      views.forEach((view) => {
        const isActive = view.dataset.contactPanelView === panelId;
        view.hidden = !isActive;
      });
    }

    function openPanel(panelId, titleText) {
      activePanel = panelId;
      if (titleEl && titleText) {
        titleEl.textContent = titleText;
      }

      showView(panelId);
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      root.classList.add('is-open');
      lockBackgroundScroll();
    }

    function closePanel() {
      if (!root.classList.contains('is-open')) return;

      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      unlockBackgroundScroll();

      window.setTimeout(() => {
        if (!root.classList.contains('is-open')) {
          root.hidden = true;
          views.forEach((view) => {
            view.hidden = true;
          });
        }
      }, reducedMotion ? 0 : 640);

      activePanel = null;
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const panelId = button.dataset.contactOpen;
        const titleText = button.querySelector('.contact-card__title')?.textContent?.trim();
        if (panelId) {
          openPanel(panelId, titleText);
        }
      });
    });

    closeTargets.forEach((target) => {
      target.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closePanel();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recovery-info"]) return;
  try {
    
  (function initRecoveryPdpTabs() {
    const root = document.querySelector('[data-recovery-pdp-tabs]');
    if (!root) return;

    const tabs = Array.from(root.querySelectorAll('[data-recovery-pdp-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-recovery-pdp-panel]'));

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const panelId = tab.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        tabs.forEach((entry) => {
          const isActive = entry === tab;
          entry.classList.toggle('is-active', isActive);
          entry.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((entry) => {
          const isActive = entry === panel;
          entry.classList.toggle('is-active', isActive);
          entry.hidden = !isActive;
        });
      });
    });
  })();

  (function syncRecoveryPdpTabsWidth() {
    const column = document.querySelector('[data-recovery-pdp-info-column]');
    const form = document.querySelector('.section-product-recovery-pdp .recovery-pdp__form');
    const mq = window.matchMedia('(min-width: 48rem)');

    function sync() {
      if (!column) return;

      if (!mq.matches || !form) {
        column.style.width = '';
        return;
      }

      const columnRect = column.getBoundingClientRect();
      const formRect = form.getBoundingClientRect();
      const width = Math.ceil(formRect.right - columnRect.left);

      column.style.width = width > 0 ? `${width}px` : '';
    }

    sync();
    mq.addEventListener('change', sync);
    window.addEventListener('resize', sync);
    window.addEventListener('recovery-pdp:column-sync', sync);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recovery-pdp"]) return;
  try {
    
  (function initRecoveryPdpHero() {
    const mediaRoot = document.querySelector('[data-recovery-pdp-media]');
    if (!mediaRoot) return;

    const heroRoot = mediaRoot.querySelector('[data-recovery-pdp-hero]');
    const isCutout = heroRoot?.dataset.cutout === 'true';
    const thumbs = Array.from(mediaRoot.querySelectorAll('[data-recovery-pdp-thumb]'));
    const prevBtn = mediaRoot.querySelector('[data-recovery-pdp-prev]');
    const nextBtn = mediaRoot.querySelector('[data-recovery-pdp-next]');
    const thumbsList = mediaRoot.querySelector('[data-recovery-pdp-thumbs]');
    let activeIndex = Math.max(
      0,
      thumbs.findIndex((thumb) => thumb.classList.contains('is-active'))
    );

    function swapHero(thumb, index) {
      if (!heroRoot || !thumb) return;

      const src = thumb.dataset.imageSrc;
      const srcset = thumb.dataset.imageSrcset;
      const alt = thumb.dataset.imageAlt || '';

      if (isCutout) {
        let heroImg = heroRoot.querySelector('.recovery-pdp__hero-img--cutout');
        if (!heroImg) {
          heroImg = document.createElement('img');
          heroImg.className = 'recovery-pdp__hero-img recovery-pdp__hero-img--cutout';
          heroRoot.innerHTML = '';
          heroRoot.appendChild(heroImg);
        }

        heroImg.classList.remove('is-visible');
        heroImg.alt = alt;
        heroImg.src = src;
        if (srcset) heroImg.srcset = srcset;
        heroImg.loading = 'eager';

        if (heroImg.complete && heroImg.naturalWidth > 0) {
          heroImg.classList.add('is-visible');
        } else {
          heroImg.addEventListener('load', () => heroImg.classList.add('is-visible'), { once: true });
        }
      } else {
        let heroImg = heroRoot.querySelector('.editorial-image__frame');
        if (!heroImg || !src) return;

        heroImg.classList.remove('is-visible');
        heroImg.alt = alt;
        heroImg.src = src;
        if (srcset) heroImg.srcset = srcset;
        heroImg.loading = 'eager';

        if (heroImg.complete && heroImg.naturalWidth > 0) {
          heroImg.classList.add('is-visible');
        } else {
          heroImg.addEventListener('load', () => heroImg.classList.add('is-visible'), { once: true });
        }
      }

      thumbs.forEach((btn, btnIndex) => {
        const isActive = btnIndex === index;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      activeIndex = index;
      scrollThumbIntoView(thumbs[index]);
      syncArrows();
    }

    function scrollThumbIntoView(thumb) {
      if (!thumb || !thumbsList) return;
      const listRect = thumbsList.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();

      if (thumbRect.left < listRect.left) {
        thumbsList.scrollLeft -= listRect.left - thumbRect.left + 8;
      } else if (thumbRect.right > listRect.right) {
        thumbsList.scrollLeft += thumbRect.right - listRect.right + 8;
      }
    }

    function syncArrows() {
      if (prevBtn) prevBtn.disabled = activeIndex <= 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= thumbs.length - 1;
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => swapHero(thumb, index));
    });

    prevBtn?.addEventListener('click', () => {
      if (activeIndex <= 0) return;
      swapHero(thumbs[activeIndex - 1], activeIndex - 1);
    });

    nextBtn?.addEventListener('click', () => {
      if (activeIndex >= thumbs.length - 1) return;
      swapHero(thumbs[activeIndex + 1], activeIndex + 1);
    });

    syncArrows();
  })();

  (function syncRecoveryPdpColumnWidth() {
    const section = document.querySelector('.section-product-recovery-pdp');
    if (!section) return;

    const mq = window.matchMedia('(min-width: 48rem)');
    const title = section.querySelector('.recovery-pdp__title');
    const lede = section.querySelector('.recovery-pdp__lede');
    const form = section.querySelector('.recovery-pdp__form');

    function sync() {
      if (!title) return;

      if (!mq.matches) {
        if (lede) lede.style.width = '';
        if (form) form.style.width = '';
        return;
      }

      const columnWidth = `${Math.ceil(title.getBoundingClientRect().width)}px`;

      if (lede) lede.style.width = columnWidth;
      if (form) form.style.width = columnWidth;

      window.dispatchEvent(new CustomEvent('recovery-pdp:column-sync'));
    }

    sync();
    mq.addEventListener('change', sync);
    window.addEventListener('resize', sync);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
